import React from 'react';
import { PageStyle } from '../Utils/generalStyles';

// Components
import ManageWaitlistSection from '../Components/ManageWaitlist';
import FooterSection from '../Components/Footer';

const ManageWaitlistPage = () => (
  <PageStyle>
    <ManageWaitlistSection />
    <FooterSection />
  </PageStyle>
);

export default ManageWaitlistPage;
